import React from 'react'

export default function Tips() {
    return (
        <>
            <div className = "tips-title">
                <h1> How Everything Works  </h1> 
            </div>
            <div className="how-it-works">
                <div className="tips">
                    <div className="tip-header"> <h3> Fill Your Info </h3> <h5> (Meal Buddy) </h5> </div>
                    <p> Make sure to fill out your current location as your CITY (i.e. Vancouver), your age and favourite ingredient to get recommended perfect food and restaurants that you and your meal buddy can go to. </p>
                </div>
                <div className="tips">
                    <div className="tip-header"> <h3> Acquiring ID </h3> <h5> (Meal Buddy Video Call) </h5> </div>
                    <p> To acquire an ID to call someone else privately, you need to first chat with them to acquire their ID. </p>
                </div>
                <div className="tips">
                    <div className="tip-header"> <h3> Join a room </h3> <h5> (Meal Buddy) </h5> </div>
                    <p> Select your favourite cuisine type and meal type. Then you will be joined into a room along with others who have the same types. What if you don't have anyone in your room? Advertise it on social media to gather new people or join a different one! </p>
                </div>
                <div className="tips">
                    <div className="tip-header"> <h3> Enter a keyword </h3> <h5> (Recipe Jackpot) </h5> </div>
                    <p> The Recipe Jackpot takes in a keyword which is an ingredient that you want in your meal choice (i.e. chicken). If you want a meal with chicken in it, it will randomly select meals with chicken. </p>
                </div>
                <div className="tips">
                    <div className="tip-header"> <h3> Custom field </h3> <h5> (Recipe Jackpot) </h5> </div>
                    <p> If you don't have any keywords you can think of, use the custom input field. Here you will have more freedom to what you can pick. You got everything from a balanced meal to a chinese cuisine. Multiple keywords are allowed!</p>
                </div>
                <div className="tips">
                    <div className="tip-header"> <h3> How do I join one of the rooms shown above? </h3> <h5> (Meal Buddy) </h5> </div>
                    <p> We block joining random rooms for security purposes. You will need to have the same information as them. The matching algorhythm is from taking all the user's inputs ordering from age-location-cuisine type-meal type. If you have the information, you can join that room.  </p>
                </div>
            </div>
        </>
    )
}
